import { combineReducers } from 'redux';
import user from './user';
import module from './module';
import reportCreationDictionaries from './reportCreationDictionaries';
import reportSummaryDictionaries from './reportSummaryDictionaries';
import reportSummary from './reportSummary';
import reportStatus from './reportStatus';
import reportCreation from './reportCreation';
import currentUser from './currentUser';
import reportView from './reportView';
import eduServiceRegistry from './listService';
import eduEventRegistry from './listEvent';
import dictionaries from './dictionaries';

export default combineReducers({
  user,
  module,
  reportCreationDictionaries,
  reportSummaryDictionaries,
  reportSummary,
  reportStatus,
  currentUser,
  reportCreation,
  reportView,
  eduServiceRegistry,
  eduEventRegistry,
  dictionaries,
});
